export default "__VITE_ASSET__e110e0ed__"